let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kwpyS")).then(() => parcelRequire('hlvWq'));